import React, { FC } from 'react';
import Select from '../../Select';
import RangePicker from '../RangePicker';
import { CombinePickerProps } from '../interface';
import './index.less';
import { PICKER_OPTION } from '../constants';
import classnames from 'classnames';

const CombinePicker: FC<CombinePickerProps> = (props) => {
  const { value, pickerOption, typeOption, switchedDefaultValue, className, startProps, endProps, onChange, ...rest } =
    props;
  const { date, picker, type } = value || {};
  /** 日期类型选择 */
  const handlePickerChange = (picker: any) => {
    onChange?.({ ...value, picker, date: switchedDefaultValue?.[picker] || [] });
  };
  /** 业务类型选择 */
  const handleTypeChange = (type: any) => {
    onChange?.({ ...value!, type });
  };
  /** 日期选择 */
  const handleDateChange = (_: any, __: any, range: any) => {
    onChange?.({ ...value, date: range });
  };

  return (
    <div className={classnames('fs-combinePicker', className)}>
      {(() => {
        if (typeOption && !props?.label) {
          return <Select hasAll={false} virtual={false} data={typeOption} value={type} onChange={handleTypeChange} />;
        }
        return null;
      })()}
      {pickerOption && !props.picker ? (
        <Select
          className="fs-combinePicker-picker-select"
          hasAll={false}
          value={picker}
          virtual={false}
          onChange={handlePickerChange}
          data={pickerOption.map((item) => ({
            name: PICKER_OPTION[item],
            code: item,
          }))}
        />
      ) : null}
      <RangePicker
        {...rest}
        value={date}
        startProps={startProps}
        endProps={endProps}
        picker={picker}
        onChange={handleDateChange}
      />
    </div>
  );
};

export default CombinePicker;
